export const getSalesNotificationTemplateIds = isQa => {
  const DOCUMENT_OPEN = isQa ? 3209704 : 135147404;
  const EMAIL_CLICK = isQa ? 3209530 : 135147406;
  const EMAIL_OPEN = isQa ? 3209531 : 135147405;
  const LEAD_REVISITS = isQa ? 3212191 : 135147402;
  const PROSPECT_REVISITS = isQa ? 3212190 : 135147403;
  return [DOCUMENT_OPEN, EMAIL_CLICK, EMAIL_OPEN, LEAD_REVISITS, PROSPECT_REVISITS];
};